import { render, staticRenderFns } from "./WorkingGroupEdit.vue?vue&type=template&id=6309bf00&"
import script from "./WorkingGroupEdit.vue?vue&type=script&lang=js&"
export * from "./WorkingGroupEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports